import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import FAQBG from "../../assets/images/Home/FAQBG.png";
import { AccordionArrowDown } from "../../assets/icons/MUI/HomeIcons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const AccordionStyle = {
  color: "#FFF",
  fontFamily: "Montserrat",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  borderRadius: "8px",
  background: "rgba(26, 26, 26, 0.70)",
};

const FAQSection = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      component="section"
      sx={{
        backgroundImage: `url(${FAQBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "850px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "39px",
          margin: "0 auto",
          width: "90%",
          maxWidth: "927px",
          alignItems: "center",
          textAlign: "center",
          padding: {
            xs: "36px 0",
            lg: "97.5px 0 123.5px",
          },
        }}
      >
        <Typography
          component="h3"
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "40px",
            fontStyle: "normal",
            fontWeight: 750,
            lineHeight: "130%",
          }}
        >
          {t("pages.home.gotQuestions")}
        </Typography>
        <Typography
          component="p"
          sx={{
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "24px",
            maxWidth: "627px",
            color: "#FFF",
          }}
        >
          {t("pages.home.findAnswers")}{" "}
          <a href="mailto:ask@goalngo.com" style={{ color: "#A1E3CB", textDecoration: "none" }}>
            {t("pages.home.emailContact")}
          </a>
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.whatIsGoBusiness")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.featuresEnhanceManagement")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.howToGetStarted")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.submitYourForm")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.featuresOffered")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.featuresEnhanceManagement")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.improveOperations")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.centralizesManagement")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel5"} onChange={handleChange("panel5")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.suitableForAllEntities")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.suitableForAllTypes")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={AccordionStyle} expanded={expanded === "panel6"} onChange={handleChange("panel6")}>
            <AccordionSummary expandIcon={<AccordionArrowDown />}>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.supportOptions")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ textAlign: currentLanguage === "en" ? "left" : "right" }}>
                {t("pages.home.customerSupport")}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQSection;
